//@flow

import React from "react";
import moment from "moment";
import config from "@config";

export default function date(dateString: string, format: string = config.dateFormat) {
  return <div className="ellipsis">{moment(dateString).format(format)}</div>;
}
